import { ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from './Button';

interface WizardFooterProps {
  onBack?: () => void;
  onNext?: () => void;
  onFinish?: () => void;
  nextLabel?: string;
  finishLabel?: string;
  backLabel?: string;
  isNextDisabled?: boolean;
  isFinishDisabled?: boolean;
  isLoading?: boolean;
  className?: string;
}

export function WizardFooter({
  onBack,
  onNext,
  onFinish,
  nextLabel = 'Next',
  finishLabel = 'Finish',
  backLabel = 'Back',
  isNextDisabled = false,
  isFinishDisabled = false,
  isLoading = false,
  className = '',
}: WizardFooterProps) {
  const showFinish = !!onFinish;

  return (
    <div
      className={`flex items-center justify-between pt-4 border-t border-surface-200 ${className}`}
    >
      {/* Back button — hidden on first step (onBack undefined) */}
      <div>
        {onBack && (
          <Button variant="secondary" onClick={onBack} disabled={isLoading}>
            <ChevronLeft className="w-4 h-4 mr-1" />
            {backLabel}
          </Button>
        )}
      </div>

      {/* Next / Finish */}
      <div>
        {showFinish ? (
          <Button
            onClick={onFinish}
            disabled={isFinishDisabled || isLoading}
            loading={isLoading}
          >
            {finishLabel}
          </Button>
        ) : (
          onNext && (
            <Button
              onClick={onNext}
              disabled={isNextDisabled || isLoading}
              loading={isLoading}
            >
              {nextLabel}
              <ChevronRight className="w-4 h-4 ml-1" />
            </Button>
          )
        )}
      </div>
    </div>
  );
}
